import { render, staticRenderFns } from "./Onomastico.vue?vue&type=template&id=1fdbe184"
import script from "./Onomastico.vue?vue&type=script&lang=js"
export * from "./Onomastico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports